// services/inventory/movement.js
import api from '../../services/axios'

const getTenant = () => {
  try {
    return sessionStorage.getItem("acc_id")
  } catch {
    return null
  }
}

export const moveDevicesToTenant = (payload) =>
  api.post('/inventory/warehouse/devices/move-to-tenant/', payload)

export const moveBoxesToTenant = (payload) =>
  api.post('/inventory/warehouse/devices/move-to-tenant/', payload)

export const createSupplyBulkOrder = async (payload) => {
  const res = await api.post("/inventory/toca/tenovi-bulk-orders/", payload)
  return res.data ?? res
}

export const returnDevicesToWarehouse = (payload) => {
  const tenant = getTenant()
  // const base = tenant ? `/devices/${tenant}/return-to-warehouse/` : `/devices/return-to-warehouse/`
  const base = `/devices/distributed/return-to-warehouse/`
  return api.post(base, payload)
}

export const sendWarrantyEmail = (payload) => {
  return api.post('/inventory/warranty/send_warranty_email/', payload)
}

export const getPendingRefurbishment = async () => {
  const res = await api.get(`/inventory/warehouse/devices/`, {
    params: { inventory_status: "Pending Refurbishment" },
  })
  return res.data ?? res
}

export const submitRefurbishment = async (serialOrImei, payload) => {
  const id = encodeURIComponent(String(serialOrImei))
  const res = await api.post(`/inventory/refurbishment/${id}/`, payload)
  return res.data ?? res
}


export const getWarrantyDevices = async (pageOrUrl = null, claimStatus = null) => {
  if (typeof pageOrUrl === "string" && (pageOrUrl.startsWith("http://") || pageOrUrl.startsWith("https://"))) {
    const res = await api.get(pageOrUrl)
    return res.data ?? res
  }

  const params = { warranty_status: "active" }
  if (claimStatus) params.warranty_claim_status = claimStatus

  if (typeof pageOrUrl === "number" || (typeof pageOrUrl === "string" && pageOrUrl.trim() !== "")) {
    params.page = pageOrUrl
  }

  const res = await api.get(`/inventory/warehouse/devices/`, { params })
  return res.data ?? res
}

 
export const getRefurbishedDevices = async (pageOrUrl = null) => {
  if (typeof pageOrUrl === "string" && (pageOrUrl.startsWith("http://") || pageOrUrl.startsWith("https://"))) {
    const res = await api.get(pageOrUrl)
    return res.data ?? res
  }

  const params = { inventory_status: "In Warehouse (Refurbished)" }
  if (typeof pageOrUrl === "number" || (typeof pageOrUrl === "string" && pageOrUrl.trim() !== "")) {
    params.page = pageOrUrl
  }

  const res = await api.get(`/inventory/warehouse/devices/`, { params })
  return res.data ?? res
}
